import React from "react";

export const LittleBr = ({margin = 0.5}) => {
  return (
    <div style={{marginBottom: margin + 'rem'}}/>
  );
};


// WEBPACK FOOTER //
// ./src/components/common/littleBr.js